export function adviserPracticeAdminsApi(path: string) {
  return {
    path,
  };
}
